// Collection tabs section — drives the shared slider controls in the tab
// bar (desktop) and keeps every counter in sync. Registered via the shared
// Eurus script guard so editor re-renders never double-register the Alpine
// component.
window.Eurus = window.Eurus || {};
window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();

if (!window.Eurus.loadedScript.has('collection-tabs.js')) {
  window.Eurus.loadedScript.add('collection-tabs.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCollectionTabs', () => ({
        active_tab: 0,
        sliderConfigs: new Map(),
        sectionObserver: null,
        prewarmed: false,
        init() {
          this.$watch('active_tab', () => {
            this.syncActive();
          });
          this.$nextTick(() => {
            this.sectionObserver = new IntersectionObserver(entries => {
              if (!entries.some(entry => entry.isIntersecting)) return;
              this.sectionObserver.disconnect();
              this.prepareSliders();
            }, { rootMargin: '200px' });
            this.sectionObserver.observe(this.$root);
          });
        },
        destroy() {
          this.sectionObserver?.disconnect();
        },
        registerSlider(el, config) {
          this.sliderConfigs.set(el, config);
          if (this.prewarmed) this.mountSlider(el);
        },
        mountSlider(el) {
          if (!el || el.splide || !window.Splide) return;
          const config = this.sliderConfigs.get(el);
          if (!config) return;
          const panel = el.closest('.ctabs__panel');
          const hidden = panel && getComputedStyle(panel).display === 'none';
          if (hidden) {
            panel.classList.add('ctabs__panel--preparing');
            panel.style.setProperty('display', 'grid', 'important');
            // Splide measures its track during mount, so hidden tabs need a
            // full-width offscreen layout until mounting is complete.
            void panel.offsetWidth;
          }
          try {
            this.$store.xSplide.load(el, config);
          } finally {
            if (hidden) {
              panel.style.setProperty('display', 'none');
              panel.classList.remove('ctabs__panel--preparing');
            }
          }
          const visibleCount = Math.max(
            1,
            Number(config.breakpoints?.[300]?.perPage) || 1,
            Number(config.breakpoints?.[1024]?.perPage) || 1,
          );
          [...el.querySelectorAll('.ctabs__slide .card-product-primary-image')]
            .slice(0, visibleCount)
            .forEach(image => {
              image.loading = 'eager';
              image.decode?.().catch(() => {});
            });
        },
        prepareSliders() {
          if (this.prewarmed) return;
          if (!window.Splide) {
            window.addEventListener('load', () => this.prepareSliders(), { once: true });
            return;
          }
          this.prewarmed = true;
          this.sliderConfigs.forEach((_, el) => this.mountSlider(el));
          this.syncActive();
        },
        activeSlider() {
          const panels = this.$root.querySelectorAll('.ctabs__panel');
          return panels[this.active_tab]?.querySelector('.ctabs__slider') || null;
        },
        pad(n) {
          return n < 10 ? '0' + n : '' + n;
        },
        setCounter(counterEl, index, length) {
          if (!counterEl) return;
          const current = counterEl.querySelector('.ctabs__counter-current');
          const total = counterEl.querySelector('.ctabs__counter-total');
          if (current) current.textContent = this.pad(index + 1);
          if (total) total.textContent = this.pad(length);
        },
        syncControls(rootEl) {
          const splide = rootEl && rootEl.splide;
          if (!splide) return;
          const index = splide.index || 0;
          const length = splide.length || 0;
          this.setCounter(rootEl.querySelector('.ctabs__counter'), index, length);
          const section = rootEl.closest('.ctabs');
          if (!section) return;
          this.setCounter(section.querySelector('.ctabs__bar-controls .ctabs__counter'), index, length);
          const controller = splide.Components.Controller;
          const prevBtn = section.querySelector('.ctabs__bar-controls .ctabs__arrow--prev');
          const nextBtn = section.querySelector('.ctabs__bar-controls .ctabs__arrow--next');
          if (prevBtn) prevBtn.disabled = controller.getPrev() < 0;
          if (nextBtn) nextBtn.disabled = controller.getNext() < 0;
        },
        syncActive() {
          this.$nextTick(() => requestAnimationFrame(() => {
            const slider = this.activeSlider();
            if (!slider?.splide) this.mountSlider(slider);
            if (slider?.splide) {
              slider.splide.refresh();
              this.syncControls(slider);
              return;
            }
            const bar = this.$root.querySelector('.ctabs__bar-controls .ctabs__counter');
            const panelTotal = slider?.querySelector('.ctabs__counter-total')?.textContent;
            if (bar && panelTotal) this.setCounter(bar, 0, parseInt(panelTotal, 10) || 1);
          }));
        },
        prev() {
          const slider = this.activeSlider();
          if (slider && slider.splide) slider.splide.go('<');
        },
        next() {
          const slider = this.activeSlider();
          if (slider && slider.splide) slider.splide.go('>');
        },
      }));
    });
  });
}
